var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "37px",
    viewBox: "0 0 51 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 4,
    stroke: "none",
    strokeWidth: 1,
    fill: "#959595",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "none",
    stroke: "#979797",
    strokeWidth: 2,
    cx: 18.5,
    cy: 18.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 34,
    y: 11,
    width: 3,
    height: 15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 11,
    width: 3,
    height: 15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(18.500000, 1.500000) rotate(90.000000) translate(-18.500000, -1.500000) ",
    x: 17,
    y: -6,
    width: 3,
    height: 15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(18.500000, 35.500000) rotate(90.000000) translate(-18.500000, -35.500000) ",
    x: 17,
    y: 28,
    width: 3,
    height: 15,
    rx: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0531c44d.svg";
export { ForwardRef as ReactComponent };